// src/styles/PersonalityTestsStyles.js
import styled from 'styled-components';
import { Card, StyledButton } from '../main/CommonStyles';

export const TestsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: ${({ theme }) => theme.spacing.lg};
`;

export const TestCard = styled(Card)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .icon-wrapper {
        font-size: 2.5rem;
        color: ${({ theme }) => theme.colors.primary};
        margin-bottom: ${({ theme }) => theme.spacing.md};
        text-align: center;
    }

    h3 {
        font-size: 1.25rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryDark};
        margin-bottom: ${({ theme }) => theme.spacing.sm};
        text-align: center;
    }

    p {
        font-size: 0.875rem;
        color: ${({ theme }) => theme.colors.textMedium};
        margin-bottom: ${({ theme }) => theme.spacing.md};
        flex-grow: 1;
    }
`;

export const StartTestButton = styled(StyledButton)`
    width: 100%;
    margin-top: auto;
`;

// Style dla aktywnego testu
export const ActiveTestWrapper = styled(Card)`
    margin-top: ${({ theme }) => theme.spacing.lg};
    padding: ${({ theme }) => theme.spacing.xl};

    .test-header {
        text-align: center;
        margin-bottom: ${({ theme }) => theme.spacing.lg};
        h2 {
            font-size: 1.75rem;
            color: ${({ theme }) => theme.colors.primaryDarker};
            margin-bottom: ${({ theme }) => theme.spacing.sm};
        }
    }

    .important-disclaimer {
        background-color: ${({ theme }) => theme.colors.dangerBg};
        color: ${({ theme }) => theme.colors.danger};
        border: 1px solid ${({ theme }) => theme.colors.danger};
        padding: ${({ theme }) => theme.spacing.md};
        border-radius: ${({ theme }) => theme.borderRadius};
        margin-bottom: ${({ theme }) => theme.spacing.lg};
        font-size: 0.9rem;
        text-align: center;
        p {
            margin: 0;
            color: ${({ theme }) => theme.colors.danger};
        }
        strong {
            font-weight: 700;
        }
    }
`;

export const QuestionWrapper = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    padding-bottom: ${({ theme }) => theme.spacing.lg};
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};

    .question-text {
        font-size: 1.1rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.textDark};
        margin-bottom: ${({ theme }) => theme.spacing.md};
    }
`;

export const AnswerOptionsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr; /* Domyślnie jedna kolumna dla opcji odpowiedzi */
    gap: ${({ theme }) => theme.spacing.sm};

    /* Można dostosować dla niektórych testów, jeśli odpowiedzi są krótkie */
    /* @media (min-width: 600px) {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    } */
`;

export const AnswerButton = styled.button`
    display: block;
    width: 100%;
    padding: ${({ theme }) => theme.spacing.md};
    font-size: 0.95rem;
    text-align: left;
    background-color: ${({ theme, $selected }) => $selected ? theme.colors.primaryLightest : theme.colors.white};
    color: ${({ theme, $selected }) => $selected ? theme.colors.primaryDark : theme.colors.textDark};
    border: 1px solid ${({ theme, $selected }) => $selected ? theme.colors.primary : theme.colors.borderColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        border-color: ${({ theme }) => theme.colors.primary};
        background-color: ${({ theme }) => theme.colors.primaryLightest};
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        background-color: ${({ theme }) => theme.colors.neutralLight};
    }
`;

export const TestControls = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${({ theme }) => theme.spacing.xl};
    padding-top: ${({ theme }) => theme.spacing.lg};
    border-top: 1px solid ${({ theme }) => theme.colors.borderColor};

    .progress-text {
        font-size: 0.9rem;
        color: ${({ theme }) => theme.colors.textMedium};
    }
`;

export const ResultsWrapper = styled(Card)`
    margin-top: ${({ theme }) => theme.spacing.lg};
    padding: ${({ theme }) => theme.spacing.xl};
    text-align: center;

    h3 {
        font-size: 1.5rem;
        color: ${({ theme }) => theme.colors.primaryDarker};
        margin-bottom: ${({ theme }) => theme.spacing.md};
    }

    .result-interpretation {
        font-size: 1rem;
        color: ${({ theme }) => theme.colors.textDark};
        margin-bottom: ${({ theme }) => theme.spacing.lg};
        line-height: 1.7;
        white-space: pre-wrap; /* Aby zachować formatowanie z \n */
    }

    .result-score { /* Opcjonalne, jeśli chcesz pokazać wynik liczbowy */
        font-size: 1.1rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.secondary};
        margin-bottom: ${({ theme }) => theme.spacing.md};
    }
`;